import { render, staticRenderFns } from "./PolicyStatusBadge.vue?vue&type=template&id=77bf10b8"
import script from "./PolicyStatusBadge.vue?vue&type=script&lang=ts"
export * from "./PolicyStatusBadge.vue?vue&type=script&lang=ts"
import style0 from "./PolicyStatusBadge.vue?vue&type=style&index=0&id=77bf10b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports